<template>
	<div class="labeled-decor-box">
		<div
			class="labeled-decor-box__content"
			:style="{
				width: width + 'px',
				height: height + 'px',
			}"
		>
			<span>{{ text }}</span>
			<div :class="`icon-${icon}`" />
		</div>
		<div
			class="labeled-decor-box__content labeled-decor-box__content--clone"
		>
			<span ref="textItem">{{ text }}</span>
			<div ref="iconItem" :class="`icon-${icon}`" />
		</div>
		<div class="labeled-decor-box__bg">
			<svg
				class="box-bg"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				version="1.1"
				preserveAspectRatio="none"
				:style="{
					width: width - 4 + 'px',
					height: height + 'px',
				}"
			>
				<defs>
					<linearGradient
						id="bb-linear-gradient1"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0%" stop-color="#111" stop-opacity="0" />
						<stop
							offset="30%"
							stop-color="#111"
							stop-opacity="0.7"
						/>
						<stop
							offset="100%"
							stop-color="#111"
							stop-opacity="0.9"
						/>
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient2"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop
							offset="0%"
							stop-color="#d5a03e"
							stop-opacity="0"
						/>
						<stop offset="100%" stop-color="#d5a03e" />
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient3"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0%" stop-color="#111" stop-opacity="0" />
						<stop
							offset="30%"
							stop-color="#111"
							stop-opacity="0.7"
						/>
						<stop
							offset="100%"
							stop-color="#111"
							stop-opacity="0.9"
						/>
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient4"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop
							offset="0%"
							stop-color="#e0b870"
							stop-opacity="0"
						/>
						<stop offset="100%" stop-color="#e0b870" />
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient5"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0%" stop-color="#111" stop-opacity="0" />
						<stop
							offset="30%"
							stop-color="#111"
							stop-opacity="0.7"
						/>
						<stop
							offset="100%"
							stop-color="#111"
							stop-opacity="0.9"
						/>
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient6"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop
							offset="0%"
							stop-color="#745621"
							stop-opacity="0"
						/>
						<stop offset="100%" stop-color="#745621" />
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient7"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0%" stop-color="#111" stop-opacity="0" />
						<stop
							offset="30%"
							stop-color="#111"
							stop-opacity="0.7"
						/>
						<stop
							offset="100%"
							stop-color="#111"
							stop-opacity="0.9"
						/>
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient8"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop
							offset="0%"
							stop-color="#d5a03e"
							stop-opacity="0"
						/>
						<stop offset="100%" stop-color="#d5a03e" />
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient9"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0%" stop-color="#111" stop-opacity="0" />
						<stop
							offset="30%"
							stop-color="#111"
							stop-opacity="0.7"
						/>
						<stop
							offset="100%"
							stop-color="#111"
							stop-opacity="0.9"
						/>
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient10"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop
							offset="0%"
							stop-color="#e0b870"
							stop-opacity="0"
						/>
						<stop offset="100%" stop-color="#e0b870" />
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient11"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0%" stop-color="#111" stop-opacity="0" />
						<stop
							offset="30%"
							stop-color="#111"
							stop-opacity="0.7"
						/>
						<stop
							offset="100%"
							stop-color="#111"
							stop-opacity="0.9"
						/>
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient12"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop
							offset="0%"
							stop-color="#745621"
							stop-opacity="0"
						/>
						<stop offset="100%" stop-color="#745621" />
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient14"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0%" stop-color="#d5a03e" />
						<stop offset="100%" stop-color="#d5a03e" />
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient15"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0%" stop-color="#111" stop-opacity="0" />
						<stop
							offset="30%"
							stop-color="#111"
							stop-opacity="0.7"
						/>
						<stop
							offset="100%"
							stop-color="#111"
							stop-opacity="0.9"
						/>
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient22"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop
							offset="0%"
							stop-color="#e0b870"
							stop-opacity="0"
						/>
						<stop offset="100%" stop-color="#e0b870" />
					</linearGradient>

					<linearGradient
						id="bb-linear-gradient24"
						x1="0%"
						y1="0%"
						x2="100%"
						y2="0%"
						gradientUnits="objectBoundingBox"
					>
						<stop
							offset="0%"
							stop-color="#745621"
							stop-opacity="0"
						/>
						<stop offset="100%" stop-color="#745621" />
					</linearGradient>
				</defs>
				<g id="dynamic-part" :style="{ width: `${width}px` }">
					<rect
						class="st1"
						:y="height - 3"
						:width="width - 4"
						height="2"
					/>
					<rect
						class="st0"
						:y="height - 3"
						:width="width - 4"
						height="2"
					/>
					<rect
						class="st3"
						:y="height - 4"
						:width="width - 4"
						height="1"
					/>
					<rect
						class="st8"
						:y="height - 4"
						:width="width - 4"
						height="1"
					/>
					<rect
						class="st7"
						:y="height - 1"
						:width="width - 4"
						height="1"
					/>
					<rect
						class="st4"
						:y="height - 1"
						:width="width - 4"
						height="1"
					/>
					<rect class="st6" y="1" :width="width - 4" height="2" />
					<rect class="st5" y="1" :width="width - 4" height="2" />
					<rect class="st2" :width="width - 4" height="1" />
					<rect class="st15" :width="width - 4" height="1" />
					<rect class="st14" y="3" :width="width - 4" height="1" />
					<rect class="st11" y="3" :width="width - 4" height="1" />
				</g>

				<g id="side-base" :transform="`translate(${width - 33.74}, 0)`">
					<polygon
						class="st24"
						:points="`27 ${joinY} 29 ${joinY - 1} 29 1 27 3`"
					/>
					<polygon
						class="st24"
						:points="`27 ${height - 3} 29 ${height - 1} 29 ${joinY - 1} 27 ${joinY}`"
					/>
					<polygon
						class="st28"
						:points="`29 1 29 ${joinY - 1} 30 ${joinY - 1.5} 30 0`"
					/>
					<polygon
						class="st28"
						:points="`29 ${height - 1} 30 ${height} 30 ${joinY - 1.5} 29 ${joinY - 1}`"
					/>
					<polygon
						class="st26"
						:points="`26 ${joinY + 0.5} 27 ${joinY} 27 3 26 4 26 ${joinY + 0.5}`"
					/>
					<polygon
						class="st26"
						:points="`26 ${height - 4} 27 ${height - 3} 27 ${joinY - 1} 26 ${joinY - 1.5} 26 ${height - 4}`"
					/>
				</g>

				<g
					id="box-arrow"
					:transform="`translate(${width - arrowWidth - 4}, ${height / 2 - arrowWidth / 2})`"
				>
					<polygon
						:class="['st27']"
						:points="`${arrowWidth} 0 ${(arrowWidth * 12.9) / 19} ${(arrowWidth * 9.5) / 19} 0 ${(arrowWidth * 9.5) / 19} ${arrowWidth} 0`"
					/>
					<polygon
						:class="['st28']"
						:points="`${arrowWidth} ${arrowWidth} 0 ${(arrowWidth * 9.5) / 19} ${(arrowWidth * 12.9) / 19} ${(arrowWidth * 9.5) / 19} ${arrowWidth} ${arrowWidth}`"
					/>
					<polygon
						:class="['st29']"
						:points="`${arrowWidth} 0 ${arrowWidth} ${arrowWidth} ${(arrowWidth * 12.9) / 19} ${(arrowWidth * 9.5) / 19} ${arrowWidth} 0`"
					/>
				</g>
			</svg>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { roundNumber } from "@/utils/number";
import { nextTick, ref, useTemplateRef, watch } from "vue";

interface Props {
	text: string;
	icon: string;
}

const { text, icon } = defineProps<Props>();

const textItem = useTemplateRef<HTMLElement>("textItem");
const iconItem = useTemplateRef<HTMLElement>("iconItem");

const width = ref<number>(300);
const height = ref<number>(33);

const updateDimensions = (): void => {
	if (!textItem.value) return;
	if (!iconItem.value) return;

	const textWidth = textItem.value?.getBoundingClientRect().width ?? 0;
	const iconWidth = iconItem.value?.getBoundingClientRect().width ?? 0;

	width.value = textWidth + iconWidth + 8 + 36;
};

watch(
	(): [string, string] => [text, icon],
	(): void => {
		nextTick((): void => {
			updateDimensions();
		});
	},
	{ immediate: true },
);

const arrowWidth = ref<number>(roundNumber(height.value / 3));
const joinY = roundNumber(height.value * (25 / height.value));
</script>

<style lang="scss" scoped>
.labeled-decor-box {
	position: relative;

	&__content {
		@include flex-row-center;
		position: relative;
		gap: 0.5rem;
		z-index: 1;

		&--clone {
			position: relative;
			opacity: 0;
			height: 0;
		}

		span {
			padding-bottom: 0.25rem;
			color: #fff3dd;
			font-size: 1rem;
			line-height: 1rem;
			user-select: none;
			text-transform: uppercase;
		}

		.icon-skip-all {
			width: 1.5rem;
			height: 0.75rem;
		}
	}

	&__bg {
		position: absolute;
		top: 0;
		left: 0;

		svg {
			background-image: linear-gradient(
				to right,
				rgba(17, 17, 17, 0) 0%,
				rgba(17, 17, 17, 0.9) 30%
			);
		}

		&-sub {
			position: relative;
		}
	}
}

.st0 {
	fill: url(#bb-linear-gradient2);
}

.st1 {
	fill: url(#bb-linear-gradient1);
}

.st2 {
	fill: url(#bb-linear-gradient9);
}

.st3 {
	fill: url(#bb-linear-gradient3);
}

.st4 {
	fill: url(#bb-linear-gradient6);
}

.st5 {
	fill: url(#bb-linear-gradient8);
}

.st6 {
	fill: url(#bb-linear-gradient7);
}

.st7 {
	fill: url(#bb-linear-gradient5);
}

.st8 {
	fill: url(#bb-linear-gradient4);
}

.st11 {
	fill: url(#bb-linear-gradient12);
}

.st12 {
	fill: url(#bb-linear-gradient15);
}

.st14 {
	fill: url(#bb-linear-gradient11);
}

.st15 {
	fill: url(#bb-linear-gradient10);
}

.st17 {
	fill: url(#bb-linear-gradient14);
}

.st20 {
	fill: url(#bb-linear-gradient22);
}

.st21 {
	fill: url(#bb-linear-gradient24);
}

.st24 {
	fill: #d5a03e;
}

.st26 {
	fill: #e0b870;
}

.st27 {
	fill: #eacc97;
}

.st28 {
	fill: #745621;
}

.st29 {
	fill: #6b501e;
}
</style>
